import React from 'react';
import { Image, View, Text, TouchableOpacity } from 'react-native';
import { MaterialIcons } from "@expo/vector-icons";

import HeaderDefault from '../../components/HeaderDefault';

import styles from './styles';

const PaymentMethod = ({ navigation, route }) => {
    return (
        <>
            <HeaderDefault title={"Escolha a forma"} />

            <View style={styles.content}>
                <View style={styles.contentList}>
                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate("CreditCardPayment")}>
                        <Image style={styles.iconInfo} source={require('../../../assets/imgs/creditCard.png')} />
                        <View>
                            <Text style={styles.titleItemList}>Cartão de crédito</Text>
                            <Text style={styles.descriptionItemList}>Compre seus ativos pelo cartão de crédito.</Text>
                        </View>
                        <MaterialIcons
                            name="keyboard-arrow-right"
                            size={25}
                            color="#2C2C2E"
                            style={{ alignSelf: 'center' }}
                        />
                    </TouchableOpacity>
                    <View style={styles.hr} />

                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate("BankSlip")}>
                        <Image style={styles.iconInfo} source={require('../../../assets/imgs/bankSlip.png')} />
                        <View>
                            <Text style={styles.titleItemList}>Boleto Bancário</Text>
                            <Text style={[styles.descriptionItemList]}>Compre seus ativos por um boleto bancário.</Text>
                        </View>
                        <MaterialIcons
                            name="keyboard-arrow-right"
                            size={25}
                            color="#2C2C2E"
                            style={{ alignSelf: 'center' }}
                        />
                    </TouchableOpacity>
                    <View style={styles.hr} />

                    {/* <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate("MyBalance", {qtd : route.params.qtd})}>
                        <Image style={styles.iconInfo} source={require('../../../assets/imgs/myBalance.png')} />
                        <View>
                            <Text style={styles.titleItemList}>Meu saldo</Text>
                            <Text style={styles.descriptionItemList}>Use o seu saldo para comprar seus ativos</Text>
                        </View>
                        <MaterialIcons
                            name="keyboard-arrow-right"
                            size={25}
                            color="#2C2C2E"
                            style={{ alignSelf: 'center' }}
                        />
                    </TouchableOpacity>
                    <View style={styles.hr} /> */}
                </View>
            </View>
        </>
    );
}

export default PaymentMethod;